export default __webpack_public_path__ + "static/media/backgound_purple.739a6291.jpg";